// Moved to @hyperframes/parsers. Re-exported here for back-compat.
export {
  CSS_URL_RE,
  PATH_ATTRS,
  isNonRelativeUrl,
  isPathInside,
} from "@hyperframes/parsers/asset-paths";
